/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CurrentStatus
 */
export interface CurrentStatus {
    /**
     * 
     * @type {number}
     * @memberof CurrentStatus
     */
    companyId: number | null;
    /**
     * 
     * @type {number}
     * @memberof CurrentStatus
     */
    centerId: number | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentStatus
     */
    processStatus: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CurrentStatus
     */
    lastUpdateDatetime: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentStatus
     */
    message: string | null;
}

/**
 * Check if a given object implements the CurrentStatus interface.
 */
export function instanceOfCurrentStatus(value: object): value is CurrentStatus {
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('centerId' in value) || value['centerId'] === undefined) return false;
    if (!('processStatus' in value) || value['processStatus'] === undefined) return false;
    if (!('lastUpdateDatetime' in value) || value['lastUpdateDatetime'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function CurrentStatusFromJSON(json: any): CurrentStatus {
    return CurrentStatusFromJSONTyped(json, false);
}

export function CurrentStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): CurrentStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['company_id'],
        'centerId': json['center_id'],
        'processStatus': json['process_status'],
        'lastUpdateDatetime': (json['last_update_datetime'] == null ? null : new Date(json['last_update_datetime'])),
        'message': json['message'],
    };
}

export function CurrentStatusToJSON(json: any): CurrentStatus {
    return CurrentStatusToJSONTyped(json, false);
}

export function CurrentStatusToJSONTyped(value?: CurrentStatus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'company_id': value['companyId'],
        'center_id': value['centerId'],
        'process_status': value['processStatus'],
        'last_update_datetime': value['lastUpdateDatetime'] == null ? value['lastUpdateDatetime'] : value['lastUpdateDatetime'].toISOString(),
        'message': value['message'],
    };
}

